import { default as api } from 'config/adminApiConf.js';

export const listProduct = async (page) => {
	try {
		let result = await api.get(`/products/vendor-product/list?page=${page}`);
		return result;
	} catch (error) {
		return error;
	}
};

export const deleteProduct = async (id) => {
	try {
		let result = await api.delete(`/products/vendor-product/delete/${id}`);
		return result;
	} catch (error) {
		return error;
	}
};
